import React, { Component } from 'react'
import Modal, { IModalProps } from '../../components/html/Modal'
import Input from "../../components/html/Input";
import Button from "../../components/html/Button";
import {ThemeProps} from "../../components/styles/themeprops";
import './ForgotPassword.css';
import ModalBox from '../../components/html/Modal';

export default class ForgotPasswordModal extends Component<IModalProps> {
  constructor(props: IModalProps) {
		super(props)
		this.onEmailChanged = this.onEmailChanged.bind(this);
  }

  state = {
	isInvalid: false,
	errorMessage: '',
	emailEntered: '',
	running:false,
  }

  onEmailChanged(event: React.ChangeEvent<HTMLInputElement>): void {
		this.setState({
			event,
			isInvalid: event.target.value === ''
		})
  }
  
  render(): JSX.Element {
    return (
      <div>
        <ModalBox open={this.props.open} onClose={this.props.onClose} title={this.props.title} closeButton={true}>
          <div className="form-container">
          	<Input label="Email address"	error={this.state.isInvalid && "Please fill in Email address"}
							disabled={this.state.running} onChange={this.onEmailChanged} />
						<div className="modal-desc">
               We&apos;ll email you a link to reset your Password
            </div>
            <div className="password-form-spacer" />
            
            <div className="divider d-flex align-items-center my-4">
			      </div>
			          
	            <Button type="button" className="btn-lg" onClick={this.props.onPasswordResetClicked} buttonClass="primary">
								Send me a password reset link
			        </Button>
	            <div className="password-form-spacer" />
	  					<Button type="button" className="btn-lg" buttonClass='secondary' onClick={this.props.onClose}>
									Cancel
							</Button>
						</div>
        </ModalBox>
      </div>
    )
  }
}